import './src/assets/css/bootstrap.min.css'
import './src/assets/css/animate.min.css'
import './src/assets/css/boxicons.min.css'
import './src/assets/css/flaticon.css'
// Removed 2026-09-12 (no component imports these libraries and no markup uses their classes):
// react-accessible-accordion fancy-example.css, react-modal-video, react-18-image-lightbox,
// react-tabs, and "swiper/css" (core styles are already included in "swiper/css/bundle").
import "/node_modules/aos/dist/aos.css";
import "swiper/css/bundle";

// Global Style
import './src/assets/css/style.css'
import './src/assets/css/responsive.css'
import './src/assets/css/dark.css'

import { trackSchedulePickup } from './src/utils/uet-tracking'

export const onInitialClientRender = () => {
  if (typeof document === 'undefined') return
  document.addEventListener('click', (e) => {
    const link = e.target && e.target.closest && e.target.closest('a[href*="app.trycents.com"]')
    if (link) trackSchedulePickup()
  })
}